import PortalToTarget from 'v3/common/components/PortalToTarget';
import LoginModal from './LoginModal';
import { useUserAuth } from './useUserAuth';
import LoginButton from './LoginButton';
import { LoginProvider } from './LoginModal/LoginProvider';
import { FC } from 'react';

type UserAuthProps = {
  shouldOpenLoginModalByDefault?: boolean;
  shouldHideTheLoginButton?: boolean;
};

const UserAuth: FC<UserAuthProps> = ({ shouldOpenLoginModalByDefault, shouldHideTheLoginButton }) => {
  const {
    isShowLoginModal,
    setIsShowLoginModal,
    domainOrPreviousLoggedInBrokerId,
    handlePreviouslyLoggedInBroker,
    goToCredentialPhase,
    hideLoginModal,
    isSubDomain,
    suggestedBrokerId,
  } = useUserAuth({ shouldOpenLoginModalByDefault });

  return (
    <div className="user-auth">
      {!shouldHideTheLoginButton && (
        <LoginButton
          domainOrPreviousLoggedInBrokerId={domainOrPreviousLoggedInBrokerId}
          handlePreviouslyLoggedInBroker={handlePreviouslyLoggedInBroker}
          setIsShowLoginModal={setIsShowLoginModal}
          isSubDomain={isSubDomain}
        />
      )}
      {/* This is to open login modal on any page that is imported  */}
      {/* shouldHideTheLoginButton will be utilized here */}
      <div className="click-to-open-modal-placeholder" onClick={() => setIsShowLoginModal(true)} />
      {(isShowLoginModal || goToCredentialPhase) && (
        <PortalToTarget className="login-modal" allowForWeb>
          <LoginProvider>
            <LoginModal
              goToCredentialPhase={goToCredentialPhase}
              hideLoginModal={hideLoginModal}
              preSelectedBrokerId={suggestedBrokerId ?? domainOrPreviousLoggedInBrokerId}
            />
          </LoginProvider>
        </PortalToTarget>
      )}
    </div>
  );
};

export default UserAuth;
